import React, { useContext, useEffect, useState } from "react";
import styles from "./styles/TableFilter.module.css"
import { LanguageContext } from "../../../Context/changeLanguageProvider";
function TableFilter({filter, setFilter, disabled ,OnAddNewAsset}) {
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(
    websiteCurrentLang.content.User.AssetType.TableFilter
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );

  useEffect(() => {
    setContent(websiteCurrentLang.content.User.AssetType.TableFilter);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  return (
    <div className={styles.filter_div}>
        <div className={styles.left}>
            <input onChange={(e)=>setFilter(e.target.value)} placeholder={dublicatedcontent.dublicatedText65} className={styles.input_input}></input>
        </div>
        <button disabled={disabled} onClick={OnAddNewAsset} className={styles.right}>
          <div className={styles.plus_logo}/>
          <div>{dublicatedcontent.dublicatedText73}</div>
        </button>
    </div>
  );
}

export default TableFilter;
